<template>
  <div class="containerStyle">
    <div class="ad" style="margin-top: 0; padding-top: 20px">
      <Advert :dataList="topAdvertList" style="padding-bottom: 20px;" />
    </div>
    <div class="menus">
      <SearchTitle :showSearch="'designer'" @submit-search="searchParams($event)" :sourceType="1" />
    </div>

    <div class="moreFilters">
      <div class="filterItem">
        <div>
          <span
            :class="viewIndex == 0 ? 'item selectView' : 'item'"
            @click="searchParam('view', 0)"
            >综合排序</span
          >
          <span
            :class="viewIndex == 1 ? 'item selectView' : 'item'"
            @click="searchParam('view', 1)"
            >最新发布</span
          >
          <span
            :class="viewIndex == 2 ? 'item selectView' : 'item'"
            @click="searchParam('view', 2)"
            >最热文章</span
          >
        </div>
        <!-- <div class="shaixuan" @mouseleave="hideSelectCity">
          <div @click="showCity=!showCity" style="margin-left:5px">
            <span>筛选：</span>
            <span>不限城市</span>
            <span><img style="padding-left:3px" src="@/assets/icons/xiajiantou.png" /></span>
          </div>
          <div >
            <el-card v-if="showCity" class="box-card" style="position:relative;z-index:11;width:300px;margin-left:-191px;overflow-x :hidden;" >
            <div >
              <div style="margin-top:-10px">不限城市</div>
              <div style=" margin:0 -20px;padding-bottom:5px;border-bottom: 1px solid #EDEEEF;"></div>
              <div class="selectCity" style="overflow-x :hidden;margin-left:-20px;">
                <div class="showLeft" style="overflow-x :hidden;">
                   <el-scrollbar style="height: 100%;overflow-x :hidden;">
                    <div :class="currSelect==0?'cityList currS':'cityList'" @click="changeCity(0)">热门城市</div>
                    <div :class="currSelect==1?'cityList currS':'cityList'" class="cityList" @click="changeCity(1)">安徽</div>
                    <div class="cityList" v-for="n in 10">澳门</div>
                   </el-scrollbar>
                </div>
                <div class="showRight">
                  <el-row>
                    <el-col :span="6"><span>北京</span></el-col>
                    <el-col :span="6"><span>南京</span></el-col>
                    <el-col :span="6"><span>上海</span></el-col>
                    <el-col :span="6"><span>深圳</span></el-col>
                    <el-col :span="6"><span>澳门</span></el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-card>
          </div>
        </div> -->
      </div>
    </div>
    <div class="designerStyle">
      <div
        v-for="(item, index) in producterList"
        :key="index"
        :style="
          index == 0
            ? 'border-bottom: 1px solid #EEEFF0;'
            : 'padding-top:25px;border-bottom: 1px solid #EEEFF0;'
        "
      >
        <DesignerV :producter="item" />
      </div>
    </div>

    <div class="footer">
      <el-pagination
        class="msg-pagination-container"
        :background="isBackground"
        :page-sizes="[4]"
        layout="total, prev, pager, next,sizes, jumper"
        @current-change="pageChange"
        :current-page="viewPageNum"
        :page-size="pageSize"
        :total="currentTotal"
      >
      </el-pagination>
    </div>
    <el-dialog
        title=""
        append-to-body
        size="medium"
        :visible.sync="loginWindow"
        width="900px"
        >
            <Login :isWindow="true" @loginAfter="loginAfter"></Login>
    </el-dialog>
    <div class="ad">
      <Advert :dataList="bottomAdvertList" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Login from '@/views/Login.vue';
import { addFollow, deleteFollow } from "@/comm/personalSapce";
import DesignerV from "@/components/DesignerV.vue";
import Advert from "@/components/GenAdvert.vue";
import SearchTitle from "@/components/SearchTitle.vue";
import { queryAdvertList, queryProducterList } from "@/comm/api";

export default {
  name: "Designer",
  components: {
    Advert,
    SearchTitle,
    DesignerV,
    Login
  },
  data() {
    return {
      showCity: false,
      slides: [
        {
          src: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1608347043080&di=29582ef7f4afbc36af1744bfb3628998&imgtype=0&src=http%3A%2F%2Fa3.att.hudong.com%2F05%2F16%2F14300000899407129891162585275.jpg",
        },
        {
          src: "https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1889725069,246509958&fm=26&gp=0.jpg",
        },
        {
          src: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1608354040349&di=828d71c8eace6ac61878e01ae0915354&imgtype=0&src=http%3A%2F%2Fi.17173cdn.com%2F2fhnvk%2FYWxqaGBf%2Fcms3%2FNmjqxObmjdDurtq.jpg",
        },
        {
          src: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1608354186922&di=e2c3a8c0d3e41563695f3f046ec58569&imgtype=0&src=http%3A%2F%2Fi1.3conline.com%2Fimages%2Fpiclib%2F200908%2F31%2Fbatch%2F1%2F39950%2F1251734380384jtwidqvc45.jpg",
        },
      ],
      categaries: [{ text: "Maya", value: "1" }],
      software: [
        { text: "Photoshop", value: "1" },
        { text: "3dsMax", value: "2" },
        { text: "Maya", value: "3" },
      ],
      subCategaries: [
        { text: "通用基础 / Zbrush", value: "1" },
        { text: "游戏设计 / 3D模型 / 2D原话", value: "2" },
        { text: "相关分享 / 作品集制作", value: "3" },
      ],

      isMoreOpen: false,
      isBackground: true,
      viewIndex: 0,
      currSelect: 0,
      topAdvertList: [],
      bottomAdvertList: [],
      producterList: [],
      viewPageNum: 1,
      pageSize: 4,
      currentTotal: 0,
      userId: "",
      loginWindow: false,
      isOver: false,
    };
  },
  created() {
    if (this.$route.query && this.$route.query.authorId) {
      //获取作者信息
      this.authorId = this.$route.query.authorId;
    }
    this.loadAdvert();
    this.loadProducter();
  },
  methods: {
    searchParams(params) {
      this.name = params.name;
      // this.classifyId = params.classifyId;
      // this.classifyPid = params.classifyPid;
      this.loadProducter();
    },
    loadProducter() {
      queryProducterList({
        pageNo: this.viewPageNum,
        pageSize: this.pageSize,
        orderBy: this.viewIndex,
        userId: this.userId
      }).then((res) => {
        if (res.success) {
          this.producterList = res.result.records;
          this.currentTotal = res.result.total;
        } else {
          console.log(res.message);
        }
      });
    },
    loadAdvert() {
      queryAdvertList({ classify: 5, site: 1 }).then((res) => {
        if (res.success) {
          this.topAdvertList = res.result;
        } else {
          console.log(res.message);
        }
      });
      queryAdvertList({ classify: 5, site: 2 }).then((res) => {
        if (res.success) {
          this.bottomAdvertList = res.result;
        } else {
          console.log(res.message);
        }
      });
    },
    pageChange(val) {
      this.viewPageNum = val;
      this.pageSize = this.pageSize;
      this.loadProducter();
    },
    moreClick() {
      this.isMoreOpen = !this.isMoreOpen;
    },
    searchParam(type, value) {
      this.viewIndex = value;
      this.loadProducter();
    },
    changeCity(index) {
      this.currSelect = index;
    },
    moreClick() {
      this.isMoreOpen = !this.isMoreOpen;
    },
    hideSelectCity() {
      this.showCity = false;
    },
    searchParam(type, value) {
      this.viewIndex = value;
    },
    loginAfter(){
        this.loginWindow=false;
        this.userId = this.$store.state.users.userInfo.id;
    },
  },
};
</script>
<style lang="stylus">
.carousel-3d-slide {
  border: none;
}
</style>
<style lang="stylus" scoped>
.containerStyle {
  width: 100%;
  background: #F3F3F5;

  .carousel {
    width: 1200px;
    margin: 0 auto;
  }

  .designerStyle {
    background: #fff;
    width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
    position: relative;
    z-index: 0;
  }

  .moreFilters {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 17px;
    background: none;
    opacity: 1;

    .filterItem {
      width: 1200px;
      margin: 0 auto;
      line-height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item {
        margin-right: 28px;
      }

      .shaixuan {
        width: 110px;
        height: 24px;
        background: #FFFFFF;
        border-radius: 4px;
        line-height: 24px;

        // margin-top:5px;
        .selectCity {
          display: flex;
          justify-content: start;
          line-height: 30px;
          height: 260px;

          .showLeft {
            padding-top: 5px;
            line-height: 30px;
            border-right: 1px solid #EDEEEF;
            margin-bottom: -20px;
            width: 100px;
            cursor: pointer;

            .currS {
              background: #fee3e0;
            }

            .cityList {
              padding-left: 20px;

              &:hover {
                background: #fee3e0;
                padding-left: 20px;
              }
            }
          }

          .showRight {
            margin-top: 5px;
            margin-left: 15px;
            cursor: pointer;

            span {
              padding: 2px 5px;
              border-radius: 4px;

              &:hover {
                background: #fee3e0;
                // padding:20px;
              }
            }
          }
        }
      }
    }

    .selectView {
      color: #F63926;
    }
  }

  .articles {
    margin-top: -3px;

    .articleContent {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
  }

  .footer {
    width: 1200px;
    margin: 0 auto;
    padding: 26px 0px 0px 0px;
    display: flex;
    justify-content: flex-end;
  }
}

.ad {
  width: 1250px;
}
</style>